import { CloseOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useMemoizedFn } from 'ahooks';
import {
  useSetConversationQuotedMsgDraft,
  useStateSafeConversationQuotedMsgDraft,
} from 'hooks/business/conversationDraft';
import { useMemo } from 'react';

const Box = styled.div`
  display: flex;
  padding: 10px 8px 4px 8px;
  justify-content: space-between;
  align-items: center;
  user-select: none;
`;
const Line = styled.div<{ from: Conversation.Message['msgFromType'] }>`
  background-color: #f7f9fa;
  border-left: 4px solid;
  border-left-color: ${({ from }) => (from === 'BUYER' ? '#8BCAC4' : '#F5BD96')};
  line-height: 1.8em;
  margin-right: 4px;
  flex: 2;
  padding: 0 4px;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
  white-space: nowrap;
  cursor: pointer;
`;

const Clz = styled(CloseOutlined)`
  cursor: pointer;
`;

export interface QuotedMessageProps {
  className?: string;
  conversation: Conversation.Conversation;
  onClick?: (msg: Conversation.Message) => void;
  onClear?: (msg: Conversation.Message) => void;
}

const QuotedMessage = (props: QuotedMessageProps) => {
  const { conversation, onClick } = props;
  const msg = useStateSafeConversationQuotedMsgDraft(conversation.conversationId);
  const updateReply = useSetConversationQuotedMsgDraft();
  const handleClear = useMemoizedFn((e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    updateReply(conversation.conversationId, '');
  });
  const handleClick = useMemoizedFn(() => onClick && msg && onClick(msg));
  const name = useMemo(() => {
    if (!msg) return null;
    const { msgFromType, fromUserName } = msg;
    if (msgFromType === 'BUYER') {
      return fromUserName;
    }
    return fromUserName || conversation.storeName;
  }, [conversation.storeName, msg]);

  if (!msg) {
    return null;
  }

  return (
    <Box onClick={handleClick}>
      <Line from={msg.msgFromType}>
        {name ? `${name}: ` : ''}
        {msg?.textContent?.text ?? ''}
      </Line>
      <Clz onClick={handleClear} />
    </Box>
  );
};
export default QuotedMessage;
